export function snakeCase(input: string): string {
  if (!input || input.length === 0) {
    return '';
  }

  if (input.length === 1) {
    return input.toLowerCase();
  }

  return input
    .replace(/(^[^a-zA-Z0-9]+)|([^a-zA-Z0-9]+$)/, '') // Remove leading/training non-letters
    .replace(/[^a-zA-Z0-9]+/g, '-')                   // Replace non-letters with dash
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')           // Separate camelCase with dashes
    .toLowerCase();
}



// WEBPACK FOOTER //
// ./src/gs-core/common/convert/snakeCase.ts